import React, { useRef, useEffect } from "react";
import { Spin, Empty } from "antd";
import {
  buildGlobalTestSpecListSubtitle,
  TEST_SPEC_SUBTITLE_NOT_CONFIGURED_LABEL,
} from "../utils/utils";
import { SpecFilterButtons, SpecListSearchInput } from "../shared/specManagerUi";
import SpecListRow from "../shared/SpecListRow";

export default function TestSpecListPanel({
  testRows,
  loading,
  loadingMore,
  searchInputValue,
  activeFilter,
  onSearchInputChange,
  onSearchSubmit,
  onFilterChange,
  onTestRowClick,
  onLoadMore,
}) {
  const listContainerRef = useRef(null);

  useEffect(() => {
    const container = listContainerRef.current;

    if (!container) return undefined;

    const handleScroll = () => {
      const tolerance = 3;
      const isAtBottom = Math.abs(
        container.scrollHeight - container.scrollTop - container.clientHeight,
      ) <= tolerance;
      if (isAtBottom) {
        onLoadMore();
      }
    };
    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, [onLoadMore]);

  return (

    <div className="SpecManager_ListPanel">

      <div className="SpecManager_FiltersContainer">
        <SpecListSearchInput
          placeholder="Search tests..."
          value={searchInputValue}
          onChange={onSearchInputChange}
          onSearch={(submittedSearch, event, searchInfo) => {
            if (searchInfo && searchInfo.source === "clear") return;
            onSearchSubmit(submittedSearch);
          }}
        />
        <SpecFilterButtons activeFilter={activeFilter} onFilterChange={onFilterChange} />
      </div>

      <div className="SpecManager_TableContainer" ref={listContainerRef}>
        {loading && !loadingMore && (
          <div className="SpecManager_LoadingCenter"><Spin /></div>
        )}

        {!loading && testRows.length === 0 && (
          <Empty description="No tests found" />
        )}

        {!loading && testRows.length > 0 && (
          <div className="SpecManager_ProductList">
            {testRows.map((testRow, rowIndex) => {
              const status = testRow.spec_status === "specs_added" || testRow.spec_status === "added"
                ? "added"
                : "pending";
              const isAdded = status === "added";
              const subtitle = isAdded
                ? buildGlobalTestSpecListSubtitle(testRow)
                : null;
              const showSubtitle = isAdded ? Boolean(subtitle) : true;
              const subtitleText = subtitle || TEST_SPEC_SUBTITLE_NOT_CONFIGURED_LABEL;
              const showWarningIcon = !isAdded
                || subtitleText === TEST_SPEC_SUBTITLE_NOT_CONFIGURED_LABEL;

              return (
                <SpecListRow
                  key={testRow.test || rowIndex}
                  title={testRow.test}
                  subtitleBlock={showSubtitle ? {
                    text: subtitleText,
                    showWarningIcon,
                  } : null}
                  status={status}
                  productCount={testRow.products_count}
                  onClick={() => onTestRowClick(testRow.test, status)}
                />
              );
            })}

            {loadingMore && (
              <div className="SpecManager_LoadingMore"><Spin size="small" /></div>
            )}
          </div>
        )}
      </div>
    </div>

  );
}
